export enum InputState {
  IDLE = 'idle',
  ACTIVE = 'active',
  SEARCH = 'search',
  WARNING = 'warning',
}
